// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__nftOj","modal":"Modal_modal__9nOdO","slide-down":"Modal_slide-down__fR0Li"};